import { canvasMediaNames } from './canvas-model-catalog'

const names: Record<string, string> = {
  'gpt-image-2': 'GPT Image 2', 'gpt-image-2.5-flare': 'GPT Image 2.5 Flare',
  'gemini-3-pro-image': 'Gemini 3 Pro Image', 'gemini-3.1-flash-image': 'Nano Banana 2',
  'vidu/vidu-image-pro_reference2image': 'Vidu Image Pro',
  'vidu/vidu-image_reference2image': 'Vidu Image',
  'vidu/vidu-image-lite_reference2image': 'Vidu Image Lite',
  'vidu/viduq3-fast_reference2image': 'Vidu Q3 Fast',
  'vidu/viduq2-pro_reference2image': 'Vidu Q2 Pro',
  'vidu/viduq2-fast_reference2image': 'Vidu Q2 Fast',
  'volc-seedream': 'Seedream 5.0', 'doubao-seedream-4-5-251128': 'Seedream 4.5',
  'volc-seedance-2.0': 'Seedance 2.0', 'volc-seedance-2.5': 'Seedance 2.5',
  'minimax-image-01': 'MiniMax Image 01', 'minimax-h3': 'MiniMax H3',
  'wan3.0-video': '通义万相 Wan 3.0',
  'minimax-speech-2.8-hd': 'MiniMax Speech 2.8 HD',
  'minimax-music-2.6': 'MiniMax Music 2.6',
  'volc-jimeng-tts': '即梦 / 豆包语音',
  'elevenlabs-sound-effects-v2': 'ElevenLabs 音效 V2',
  'deepseek-v4-pro': 'DeepSeek V4 Pro', 'deepseek-flash': 'DeepSeek Flash',
  'deepseek-v4-flash': 'DeepSeek V4 Flash', 'deepseek-v4-flash-vision-exp': 'DeepSeek V4 Flash Vision',
  'kimi-k2.6': 'Kimi K2.6', 'doubao-seed-2-0-lite-260215': '豆包 Seed 2.0 Lite',
  'gpt-6-astra': 'GPT-6 Astra', 'gpt-5.6-sol': 'GPT-5.6 Sol',
}
export const quoteModelName = (model: string) => canvasMediaNames[model] || names[model] || model
export function externalQuoteModels<T extends { model: string; kind: string }>(catalog: T[]): T[] {
  return catalog.filter(row => row.kind === 'text' || Object.prototype.hasOwnProperty.call(canvasMediaNames, row.model))
}

// Local preview follows Redmine #1253 production activation record (2026-10-20).
// Gemini and MiniMax speech were NOT activated; keep their entries separate.
// Production /quote-rules already resolves the active server policies.
const previewGroups: Record<string, string[]> = {
  'volc-seedance-2.0': ['volc-seedance-2.0-fast', 'volc-seedance-2.0-mini'],
  'vidu/vidu-image-pro_reference2image': ['vidu/vidu-image_reference2image', 'vidu/vidu-image-lite_reference2image', 'vidu/viduq3-fast_reference2image', 'vidu/viduq2-pro_reference2image'],
}
export function previewQuoteModels<T extends { model: string; kind: string }>(catalog: T[]): T[] {
  const hidden = new Set(Object.values(previewGroups).flat())
  return externalQuoteModels(catalog).filter(row => !hidden.has(row.model))
}
export const quoteCostNote = '按当前计价规则估算，实际费用以最终用量及供应商账单为准。'
export function quoteErrorMessage(message: string): string {
  return /聚合|候选|路由|权重|routing|candidate/i.test(message) ? '当前模型计价服务暂不可用，请稍后重试。' : message
}
